import React from "react";
import PlayArrowIcon from "@mui/icons-material/PlayArrowOutlined";
import styled from "styled-components";
import { theme } from "../../theme";

const ListItemStyled = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;

  & .title {
    font-size: 18px;
    padding: 0;
  }

  & .paragraph {
    padding: 0;
    margin-top: 0;
  }
`;

export const ListItem = ({ title, iconColor = "blue", children }) => {
  return (
    <ListItemStyled>
      <PlayArrowIcon style={{ color: theme.colors[iconColor] }} />
      <div>
        <p className="paragraph" style={{ fontSize: 18, fontWeight: 800 }}>
          {title}
        </p>
        <p className="paragraph">{children}</p>
      </div>
    </ListItemStyled>
  );
};
